<iframe *ngIf="iframeSrc" #iframe id="ePower" name="ePower" [src]="iframeSrc" scrolling="no" frameborder="0"></iframe>
